import cx from "classnames";
import React from "react";

import styles from "./LoadingBar.mscss";

interface OwnProps {
    className?: string;
    loading: boolean;
}

interface State {
    progress: number;
    full: boolean;
    show: boolean;
    wait: boolean;
}

type Props = OwnProps;

export class LoadingBar extends React.Component<Props> {
    public state: State = {
        show: true,
        full: false,
        progress: 0,
        wait: false,
    };

    private timer: number;
    private waitTimer: number;
    private removeTimer: number;
    private mounted: boolean;

    public componentDidMount() {
        if (this.props.loading) {
            this.start();
        }
        this.mounted = true;
    }

    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
        if (this.props.loading && !prevProps.loading) {
            this.start();
        } else if (!this.props.loading && prevProps.loading) {
            this.complete();
        }
    }

    public componentWillUnmount() {
        window.clearTimeout(this.timer);
        window.clearTimeout(this.waitTimer);
        window.clearTimeout(this.removeTimer);
        this.mounted = false;
    }

    public render() {
        const { className } = this.props;
        const { show, full } = this.state;

        if (!show) {
            return null;
        }

        return (
            <div
                className={cx(styles.LoadingBar, className, full && styles["LoadingBar--full"])}
                style={this.barStyle()}
            />
        );
    }

    private start = () => {
        window.clearTimeout(this.timer);
        this.setState({
            show: true,
            progress: 0,
        });

        this.timer = window.setTimeout(this.increment, 250);
    };

    private complete = () => {
        window.clearTimeout(this.timer);
        this.setState(
            {
                progress: 1,
            },
            this.checkIfFull,
        );
    };

    private increment = () => {
        const current = this.state.progress;

        if (current >= 0.99) {
            return;
        }

        let rnd = 0;
        if (current >= 0 && current < 0.25) {
            // Start out between 3 - 6% increments
            rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
        } else if (current >= 0.25 && current < 0.65) {
            // increment between 0 - 3%
            rnd = (Math.random() * 3) / 100;
        } else if (current >= 0.65 && current < 0.9) {
            // increment between 0 - 2%
            rnd = (Math.random() * 2) / 100;
        } else if (current >= 0.9 && current < 0.99) {
            // finally, increment it .5 %
            rnd = 0.005;
        }

        this.setState({ progress: current + rnd });
        this.timer = window.setTimeout(this.increment, 500);
    };

    private checkIfFull = () => {
        if (!this.mounted) {
            return;
        }

        if (this.state.progress >= 1) {
            this.setState({ wait: true });

            window.clearTimeout(this.waitTimer);
            this.waitTimer = window.setTimeout(() => {
                if (!this.mounted) {
                    return;
                }

                this.setState({ full: true });

                window.clearTimeout(this.removeTimer);
                this.removeTimer = window.setTimeout(() => {
                    if (!this.mounted) {
                        return;
                    }

                    // Remove bar element
                    this.setState({
                        show: false,
                        progress: 0,
                        wait: false,
                    });
                }, 250);
            }, 700);
        }
    };

    private barStyle = () => {
        const { wait, progress } = this.state;
        if (!wait) {
            return {
                width: `${progress * 100}%`,
            };
        } else {
            return {
                width: "100%",
            };
        }
    };
}
